export const API_PATH = {
  AUTH: {
    SIGN_IN: "/auth/login",
    SIGN_UP: "/auth/register",
    FORGOT_PASSWORD: "/auth/password/forgot",
    CHANGE_PASSWORD: "/auth/password/change",
    FORGOT_OTP_VERIFY: "/auth/password/verify-otp",
    SIGN_UP_OTP_VERIFY: "/auth/verify-account",
    RESEND_OTP: "/auth/login/otp",
    RESEND_SIGNUP_OTP: "/auth/resend-verification-code",
    RESEND_FORGOT_PASSWORD_OTP: "/auth/password/forgot",
    VERIFY_OTP: "/auth/login/otp/verify",
    RESET_PASSWORD: "/auth/password/reset",
    LOG_OUT: "/auth/logout",
    ADD_PRIVACY_POLICY: "/privacy_policy/admin/privacy-policy",
    ADD_TERMS: "/terms_conditions/admin/terms",
    GET_PRIVACY_POLICY: "/privacy_policy/privacy-policy",
    GET_TERMS: "/terms_conditions/terms",
    ACCEPT_TERMS: "/auth/accept-terms",
    SOCIAL_SIGNIN: "/auth/social-signin",
  },
  PROFILE: {
    UPDATE_PROFILE: "user/me/profile",
    UPDATE_PREFERENCES: "/profile/preferences",
    PROFILE_DATA: "/profile/me",
    PROFILE_STATUS: "/profile/status",
    UPGRADE: "/profile/upgrade",
    QUESTIONS: "/questions",
    ABOUT_SELFI: "/user/me/profile",
    USER_PHOTOS: "/user/me/photos",
    DELETE_ACCOUNT: "/user/me/account",
    PAUSE_ACCOUNT: "/user/me/account/pause",
  },
  UPLOAD: "user/upload",
  UPLOAD_SELFIE: "/user/upload/selfie",
  WALLET: {
    PLANS: "/plans",
    CREATE_PAYMENT_INTENT: "/plans/create-payment-intent",
    TRANSACTIONS: "/tokens/transactions",
  },
  NOTIFICATIONS: {
    LIST: "/notifications",
    SETTINGS: "/notifications/settings",
  },
  FAQS: {
    LIST: "/faqs",
  },
  MATCHES: {
    LIST: "/matches",
    REQUESTS: "/matches/requests",
    LIKED_ME: "/matches/liked-me",
    I_LIKED: "/matches/i-liked",
    VISITORS: "/user/me/visitors",
    LIKE: "/matches/like",
    NOT_INTERESTED: "/matches/not-interested",
    UNLOCK_ALBUM: "/matches",
    OVERRIDE: "/matches",
    SUBMIT: "/matches",
    DISMISS: "/matches",
    VOTES: "/matches",
    CIRCLE_MEMBERS: (matchId) => `/matches/${matchId}/circle-members`,
    CIRCLE_MEMBERS_REPLACE: (matchId) => `/matches/${matchId}/circle-members/replace`,
  },
  DASHBOARD: {
    DASHBOARD_USERS: "/user/discover",
    ONE_USER: "/user/me/one-user",
    UNLOCKED_PROFILE: "/user/me/unlocked-profile",
  },
  CIRCLE: {
    JOIN: "/circle/join",
    MEMBERS: "/circle/members",
    MEMBERS_SWAP: "/circle/members/swap",
    DETAILS: "/circle/details",
    MY_MEMBERSHIPS: "/circle/my-memberships",
    MATCH_STATUS: "/circle/match-status",
    VOTE_REQUESTS: "/circle/vote-requests",
    INVITE_TEMPLATE: "/circle/invite-template",
    INVITE_EMAIL: "/circle/invite-email",
  },
  MATCHES_EXT: {
    PROCEED_TO_FINAL_VOTE: "/matches", // append /:matchId/proceed-to-final-vote
  },
  CHAT: {
    CONVERSATIONS: "/chat/conversations",
    MATCH_CONVERSATION: "/chat/match",
    MESSAGES: "/chat",
    UNLOCK: "/chat/conversations",
    READ: "/chat",
    SEND: "/chat/send",
    REPORT: "/chat/report",
  },
  CALLS: {
    AGORA_START: "/calls/agora/session",
    AGORA_JOIN: "/calls/agora/join",
    EXTEND: "/calls/extend",
  },
};
